<template>
  <div>
    <div class="stage-one">
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-sm-12">
            <div>
              <BaseInput
                :inputType="'number'"
                v-model="formBody.accountNumber"
                placeholder="Customer Account Number"
                :hasPreIcon="false"
                :label="'Customer Account Number'"
                :class="{
                  error: $v.formBody.accountNumber.$error
                }"
                @blur="$v.formBody.accountNumber.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.accountNumber.$error">
                <p
                  v-if="!$v.formBody.accountNumber.required"
                  class="form-error-message"
                >
                  Customer Account Number is required
                </p>

                <p
                  v-if="!$v.formBody.accountNumber.numeric"
                  class="form-error-message"
                >
                  Customer Account Number has to be a Number
                </p>
              </template>
            </div>
          </div>
        </div>
        <p class="text-right">
          <span v-if="loader.actionButtonLoader" class="formLoaderHold">
            <BaseComponentLoader />
          </span>
          <span v-else>
            <button type="submit" class="btn btn-primary mr-1">
              Account Enquiry
            </button>
          </span>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { numeric, required } from "vuelidate/lib/validators";
import StoreUtils from "../../../../../utils/BaseUtils/StoreUtils";

export default {
  name: "CustomerAccountEnquiryForm",
  data() {
    return {
      formBody: this.freshFormBodyObject()
    };
  },
  computed: {
    ...mapState(["ft", "loader"])
  },
  validations: {
    formBody: {
      accountNumber: { required, numeric }
    }
  },
  created() {
    StoreUtils.dispatch("ft/resetState");
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        StoreUtils.dispatch(
          StoreUtils.actions.ft.CUSTOMER_ACCOUNT_ENQUIRY,
          this.formBody
        );
      }
    },

    freshFormBodyObject() {
      return {
        source: "WEB"
      };
    }
  }
};
</script>

<style scoped></style>
